import { render, staticRenderFns } from "./CreateTypeModal.vue?vue&type=template&id=e4bc587c&scoped=true&lang=pug&"
import script from "./CreateTypeModal.vue?vue&type=script&lang=js&"
export * from "./CreateTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTypeModal.vue?vue&type=style&index=0&id=e4bc587c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bc587c",
  null
  
)

export default component.exports